module.exports = __webpack_public_path__ + "img/bg.6a051959.svg";